import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { EventEmitter, Output, Input, ViewEncapsulation, Component } from '@angular/core';
import * as i4 from 'primeng/divider';
import { DividerModule } from 'primeng/divider';
import * as i2 from 'primeng/sidebar';
import { SidebarModule } from 'primeng/sidebar';
import * as i3 from 'primeng/api';
const _c0 = ["*"];
function HeaderMenuComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 5);
    i0.ɵɵelement(1, "use");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate1("href", "", ctx_r0.icons, "#close");
  }
}
function HeaderMenuComponent_ng_template_2_img_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "img", 8);
    i0.ɵɵlistener("click", function HeaderMenuComponent_ng_template_2_img_1_Template_img_click_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.logoClick($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("src", ctx_r0.logoSrc, i0.ɵɵsanitizeUrl)("alt", ctx_r0.logoAltText);
  }
}
function HeaderMenuComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, HeaderMenuComponent_ng_template_2_img_1_Template, 1, 2, "img", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.logoSrc);
  }
}
function HeaderMenuComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
let HeaderMenuComponent = /*#__PURE__*/(() => {
  class HeaderMenuComponent {
    constructor() {
      this.sidebarVisible = false;
      this.logoSrc = '';
      this.logoAltText = '';
      this.onLogoClick = new EventEmitter();
      this.onHeaderMenuShow = new EventEmitter();
      this.onHeaderMenuHide = new EventEmitter();
      this.headerMenuVisibleChange = new EventEmitter();
      this.icons = 'assets/pds-icons.svg';
    }
    onSidebarShow(event) {
      this.onHeaderMenuShow.emit(event);
    }
    onSidebarHide(event) {
      this.onHeaderMenuHide.emit(event);
    }
    sidebarVisibleChange(event) {
      this.headerMenuVisibleChange.emit(event);
    }
    logoClick(event) {
      this.onLogoClick.emit(event);
    }
    static {
      this.ɵfac = function HeaderMenuComponent_Factory(t) {
        return new (t || HeaderMenuComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HeaderMenuComponent,
        selectors: [["pds-header-menu"]],
        hostVars: 2,
        hostBindings: function HeaderMenuComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("pds-header-menu", true);
          }
        },
        inputs: {
          sidebarVisible: "sidebarVisible",
          logoSrc: "logoSrc",
          logoAltText: "logoAltText"
        },
        outputs: {
          onLogoClick: "onLogoClick",
          onHeaderMenuShow: "onHeaderMenuShow",
          onHeaderMenuHide: "onHeaderMenuHide",
          headerMenuVisibleChange: "headerMenuVisibleChange"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 5,
        vars: 2,
        consts: [["ariaCloseLabel", "close", 3, "visibleChange", "onShow", "onHide", "visible", "showCloseIcon"], ["pTemplate", "closeicon"], ["pTemplate", "header"], [1, "pds-menu-header-divider"], ["pTemplate", "content"], [1, "pds-icon"], [1, "pds-header-menu-header-container"], ["height", "46", 3, "src", "alt", "click", 4, "ngIf"], ["height", "46", 3, "click", "src", "alt"]],
        template: function HeaderMenuComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "p-sidebar", 0);
            i0.ɵɵtwoWayListener("visibleChange", function HeaderMenuComponent_Template_p_sidebar_visibleChange_0_listener($event) {
              i0.ɵɵtwoWayBindingSet(ctx.sidebarVisible, $event) || (ctx.sidebarVisible = $event);
              return $event;
            });
            i0.ɵɵlistener("onShow", function HeaderMenuComponent_Template_p_sidebar_onShow_0_listener($event) {
              return ctx.onSidebarShow($event);
            })("onHide", function HeaderMenuComponent_Template_p_sidebar_onHide_0_listener($event) {
              return ctx.onSidebarHide($event);
            })("visibleChange", function HeaderMenuComponent_Template_p_sidebar_visibleChange_0_listener($event) {
              return ctx.sidebarVisibleChange($event);
            });
            i0.ɵɵtemplate(1, HeaderMenuComponent_ng_template_1_Template, 2, 2, "ng-template", 1)(2, HeaderMenuComponent_ng_template_2_Template, 2, 1, "ng-template", 2);
            i0.ɵɵelement(3, "p-divider", 3);
            i0.ɵɵtemplate(4, HeaderMenuComponent_ng_template_4_Template, 1, 0, "ng-template", 4);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵtwoWayProperty("visible", ctx.sidebarVisible);
            i0.ɵɵproperty("showCloseIcon", true);
          }
        },
        dependencies: [CommonModule, i1.NgIf, SidebarModule, i2.Sidebar, i3.PrimeTemplate, DividerModule, i4.Divider],
        encapsulation: 2
      });
    }
  }
  return HeaderMenuComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { HeaderMenuComponent };
